module.exports = __webpack_public_path__ + "/bundle/asset/exam-2-f7fa29dce192d8cd49068df2dea6b0c1.png";